import { UnstyledButton, UnstyledButtonProps, theme } from "@aksara-ui/react";
import React from "react";
import styled from "styled-components";

export interface PaginationButtonProps
  extends UnstyledButtonProps,
    React.ComponentPropsWithoutRef<"button"> {
  isActive?: boolean;
}

const PaginationButtonStyled = styled(UnstyledButton)<{
  isActive?: boolean;
}>`
  display: inline-flex;
  outline: none;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  textAlign: center;
  border-radius: 8px;
  border: 1px solid transparent;
  user-select: none;
  background-color: ${(props) => (props.isActive ? theme.colors.blue07 : "")};
  color: ${(props) => (props.isActive ? theme.colors.white : "")};
  
  &:hover {
    background-color: ${(props) =>
      props.isActive ? theme.colors.blue07 : theme.colors.grey01};
  }
  &:focus {
    background-color: ${(props) =>
      props.isActive ? theme.colors.blue07 : theme.colors.grey01};
    border: 2px solid rgba(175, 214, 255, 0.7);
  }
  &:active {
    background-color: ${(props) =>
      props.isActive ? theme.colors.blue07 : theme.colors.blue01};
  }
`;

const PaginationButton = React.forwardRef<
  HTMLButtonElement,
  PaginationButtonProps
>(({ className, style, sx, isActive, children, ...rest }, ref) => {
  return (
    <PaginationButtonStyled
      ref={ref}
      className={className}
      style={style}
      isActive={isActive}
      {...rest}
      type={"button"}
    >
      {children}
    </PaginationButtonStyled>
  );
});

PaginationButton.displayName = "PaginationButton";

export default PaginationButton;
